import { Badge } from "../../../components/tailwind/badge";
import { Button } from "../../../components/tailwind/button";
import { BsWhatsapp } from "react-icons/bs";
import { HEADER_BUTTONS_CONFIG } from "../constants/dashboardConstants";
import { WhatsAppPageIntro } from "./WhatsAppPageIntro";

export const DashboardHeader = ({
    isConnected,
    onConnectClick,
}) => {
    return (
        <WhatsAppPageIntro
            description="Overview of delivery, phone status, and quick actions for your WhatsApp business account."
            actions={
                <>
                    <div className="flex items-center gap-2 bg-[hsl(217,33%,17%)] dark:bg-slate-800 rounded-lg px-3 py-2 border border-transparent dark:border-slate-700">
                        <span className="text-gray-400 dark:text-slate-400 text-xs font-medium">WhatsApp API</span>
                        <span className="text-slate-500 dark:text-slate-600 text-xs" aria-hidden>•</span>
                        {isConnected ? (
                            <Badge className="bg-[hsl(158,48%,38%)]/20 text-[hsl(158,45%,55%)] border border-[hsl(158,48%,38%)]/30 text-xs">
                                <div className="h-1.5 w-1.5 rounded-full bg-[hsl(158,45%,55%)] mr-1 animate-pulse" />
                                LIVE
                            </Badge>
                        ) : (
                            <Badge className="bg-amber-500/20 text-amber-400 border-amber-500/30 text-xs">
                                PENDING
                            </Badge>
                        )}
                    </div>
                    {!isConnected && (
                        <Button
                            size="sm"
                            onClick={onConnectClick}
                            className={`${HEADER_BUTTONS_CONFIG.connect.className} h-8 px-4 gap-1.5 text-xs hover:cursor-pointer`}
                            data-testid={HEADER_BUTTONS_CONFIG.connect.testid}
                        >
                            <BsWhatsapp className="h-3.5 w-3.5" />
                            {HEADER_BUTTONS_CONFIG.connect.label}
                        </Button>
                    )}
                </>
            }
        />
    );
};
